import {useContext, useEffect} from 'react';
import { useQuery } from 'react-query';
import { getExternalAutoInfo } from '../../requests/externalAutoForm.api';
import { ExternalAutoInfoResponse, ReturnHookCard } from './Card.types';
import { ExternalAutoFormContext } from '../../pages/mfExternalAutoForm.context';
import { currency } from '../../../shared/hooks/useMask';

export const useAutoCard = (): ReturnHookCard => {
  const {
    leadIdState: [leadId],
    autoInfoState: [, setAutoInfo],
  } = useContext(ExternalAutoFormContext);
  const { data, isSuccess, isLoading, refetch } = useQuery(
    ['getExternalAutoInfo', leadId],
    async (): Promise<ExternalAutoInfoResponse> =>
      (await getExternalAutoInfo().request({})).data,
    {
      enabled: Boolean(leadId),
      select: (data: ExternalAutoInfoResponse): ExternalAutoInfoResponse => {
        setAutoInfo(data);
        return {
          ...data,
          price: currency.getMaskedValue(String(data.price)),
          year: String(data.year),
          kmTraveled: String(data.kmTraveled),
        };
      },
    },
  );
  
  useEffect(() => {
    if (leadId) {
      refetch();
    }
  }, [leadId, refetch]);
  
  return {
    isSuccess,
    isLoading,
    autoInfo: data,
  };
};
